import { lazyLoad } from 'utils/loadable';

export const DraggableWindow = lazyLoad(
  () => import('./index'),
  module => module.DraggableWindow,
);
